import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ['row', 'selectAll']

  connect() {
    this.syncSelectAll()
  }

  copyTheoreticalQuantities() {
    event.preventDefault()

    this.rowTargets.forEach(row => {
      const value = row.dataset.theoretical
      const input = row.querySelector("input[name*='[counted_quantity]']")
      if (input && value) input.value = value
    })
  }


  toggleMode(event) {
    const mode = event.target.value
    const checkboxes = this.element.querySelectorAll("input[type='checkbox']")
    checkboxes.forEach(cb => {
      cb.checked = (mode === "total")
    })
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.lineCheckboxes().forEach(cb => { cb.checked = checked })
  }

  syncSelectAll() {
    if (!this.hasSelectAllTarget) return

    const lines = this.lineCheckboxes()
    this.selectAllTarget.checked = lines.length > 0 && lines.every(cb => cb.checked)
  }

  lineCheckboxes() {
    return Array.from(this.element.querySelectorAll("input[type='checkbox']"))
      .filter(cb => cb !== this.selectAllTarget)
  }

}
